import { render } from "./ReloadPage.vue?vue&type=template&id=5e0c9128&scoped=true"
import script from "./ReloadPage.vue?vue&type=script&lang=js"
export * from "./ReloadPage.vue?vue&type=script&lang=js"

import "./ReloadPage.vue?vue&type=style&index=0&id=5e0c9128&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0c9128"]])

export default __exports__